export default "__VITE_ASSET__BfsdBtWq__"